// Stable per-device identifier used as the auth session key (x-device-id header).
// Lives in the SAME localStorage as the tokens, so the id and the tokens share
// one lifetime (clearing storage clears both → a clean re-login).

const DEVICE_ID_KEY = "merchantDeviceId";

export const getDeviceId = () => {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;

    const generated = `web-merchant-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 10)}`;
    localStorage.setItem(DEVICE_ID_KEY, generated);
    return generated;
  } catch {
    return null;
  }
};
